import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

import ordersRequest from "@/services/api/account/orders";

import { OrderItem, OrdersData } from "./types";

import { IPageMeta } from "@/services/interfaces";

const initialMeta = {
  h1: "",
  title: "",
  breadcrumbs: [],
};

@Module({ name: "account/orders", namespaced: true })
export default class OrdersModule extends VuexModule {
  data: OrdersData | null = null;
  meta: IPageMeta = initialMeta;

  get getOrders() {
    return this.data?.orders;
  }
  get getHeaders() {
    return this.data?.headers;
  }
  get getLinks() {
    return this.data?.links;
  }
  get getMeta() {
    return this.meta;
  }

  @Mutation
  ORDERS_SET_DATA(data: OrdersData | null) {

    // if (data?.orders) {
    //   data.orders.forEach(order => {
    //     if (order.items[0]) {
    //       order.items[0] = {
    //         ...order.items[0],
    //         price: 78400,
    //         promo_price: 57200,
    //         promo_stock: 4,
    //         stock: 20,
    //         quantity: 5,
    //       } as any;
    //     }
    //   });
    // }

    this.data = data;
  }

  @Mutation
  ORDERS_SET_META(data: IPageMeta) {
    this.meta = data;
  }

  @Mutation
  ORDERS_SET_ORDER_PRODUCTS({
    data,
    id,
  }: {
    data: Array<OrderItem>;
    id: number;
  }) {
    if (this.data) {
      const copy = JSON.parse(JSON.stringify(this.data));
      copy.orders[id].items = data;
      this.data = copy;
    }
  }

  @Action
  async requestOrders(): Promise<void> {
    const res = await ordersRequest();
    if (res.status && res.status >= 200 && res?.status < 400) {
      const { data, meta } = res.data;
      if (meta) this.ORDERS_SET_META(meta);
      if (data) this.ORDERS_SET_DATA(data);
    }
  }
}
